import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserModel } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class MMCPermissionsGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return new Promise((resolve, reject) => {
      this.authService.getUserLogged().subscribe({
        next: (user: UserModel) => {
          if (user) {
            resolve(user.client.key === 'C-95a684ae-9a57-466e-9028-ce953194b7f5');
          }
        }, // Resolve with the first emitted value
        error: err => reject(err), // Reject if there is an error
        complete: () => {
          // Optionally handle completion if needed, though resolve will be called on the first emission
        },
      });
    });
    // return this.authService.getCurrentUser()?.client.key === 'C-95a684ae-9a57-466e-9028-ce953194b7f5';
  }
}
